import { createFileRoute } from '@tanstack/react-router';
import { SitesPage } from '@/features/workforce/sites/SitesPage';
import { MobileSites } from '@/features/workforce/sites/mobile/MobileSites';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';

export const Route = createFileRoute('/_app/workforce/sites/')({ component: SediPage });

/**
 * `/workforce/sites` — le sedi dell'organizzazione, in MaeDesign.
 *
 * Era la tabella generica con la modifica in modale; l'URL non è cambiato, così i link e le
 * voci di menu che ci puntavano continuano a funzionare. La scheda della singola sede è la
 * rotta sorella `$siteId`.
 */
function SediPage() {
  return useIsMobileShell() ? <MobileSites /> : <SitesPage />;
}
